module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-wedding-movie@2x-1979205525a72660d272640e1c23cc2a.webp";